import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { defaultLeaguePhotos } from "./marketingPhotosConfig";

/**
 * Static three-up stills — one photo per league, not a carousel.
 * Pages pass `items` when they want different photos than the marketing defaults.
 */
const LeaguePhotoRow = ({ items = defaultLeaguePhotos, sx }) => (
  <Box
    component="section"
    aria-label="Across baseball, basketball, and football"
    sx={sx}
  >
    <Typography
      variant="overline"
      sx={{
        display: "block",
        mb: 2,
        letterSpacing: "0.12em",
        color: "text.secondary",
      }}
    >
      Across the leagues
    </Typography>
    <Grid container spacing={2}>
      {items.map((item) => (
        <Grid item xs={12} sm={4} key={item.src}>
          <Box component="figure" sx={{ m: 0 }}>
            <Box
              component="img"
              src={item.src}
              alt={item.alt}
              sx={{
                width: "100%",
                height: { xs: 180, md: 220 },
                objectFit: "cover",
                objectPosition: item.objectPosition,
                borderRadius: 2,
                display: "block",
              }}
            />
            <Typography
              component="figcaption"
              variant="body2"
              sx={{ mt: 1.25, color: "text.secondary", fontWeight: 500 }}
            >
              {item.caption}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default LeaguePhotoRow;
